"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgRocket64 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", role: "img" }, props, { children: (0, jsx_runtime_1.jsxs)("g", __assign({ transform: "translate(0 .5)", fill: "none", fillRule: "evenodd" }, { children: [(0, jsx_runtime_1.jsx)("rect", { fill: "none", width: 64, height: 64, rx: 1 }), (0, jsx_runtime_1.jsx)("path", { d: "m37.025 16.572 10.36 10.36m-14.423-8.106a13.876 13.876 0 0 0-17.516 5.735l5.972 5.972m23.721.427a13.876 13.876 0 0 1-5.7 17.594l-5.997-5.997m-4.767 2.624-9.856-9.856s8.418-20.94 32.031-22.175c-1.334 23.51-22.175 32.03-22.175 32.03ZM33.95 33.95a3.9 3.9 0 1 0 0-7.8 3.9 3.9 0 0 0 0 7.8Zm-18.358 8.942a3.9 3.9 0 0 1 5.516 5.516c-1.95 1.95-7.958 2.442-7.958 2.442s.492-6.008 2.442-7.958Z", strokeLinecap: "square", stroke: "currentColor" })] })) }))); };
exports.default = SvgRocket64;
